import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import DonationContext from '../../../../context/DonationContext/DonationContext';
import { donationManageActions } from '../../../../helpers/donations';
import RescueSizeSelector from './RescueSize/RescueSizeSelector';
import FoodTypes from './FoodTypes/FoodTypes';
import LbsSelector from './Lbs/LBSSelector';
import { fetchDonationSizesIfNeeded } from '../../../../actions/donationSizes';

const RequestToDonateDonationStep = () => {
  const dispatch = useDispatch();
  const rescueSizes = useSelector((state) => state.entities.rescueSizes);
  const [lbsValue, setLbsValue] = useState('');

  const {
    rescue_size: rescueSize,
    food_types: foodTypes,
    food_type_other: foodTypeOther,
    lbs,
  } = useSelector((state) => state.ui.donation_new.draft);
  const rescueSizesArray = rescueSizes.sorted;

  useEffect(() => {
    setLbsValue(lbs); // update value on redux change, prevents from multiple page re-renders
  }, [lbs]);

  useEffect(() => {
    dispatch(fetchDonationSizesIfNeeded());
  }, []);

  const { onFieldChange, errors, isLoading, hasFoodDonorDefined } = useContext(DonationContext);

  const rescueSizeValue = (() => {
    if (rescueSize) {
      return rescueSize.id;
    }

    if (rescueSizesArray && rescueSizesArray.length) {
      return rescueSizesArray[0].id;
    }

    return null;
  })();

  const handleCheck = ({ foodType, checked }) => {
    if (checked) {
      return onFieldChange(donationManageActions.add_food_type, foodType);
    }

    return onFieldChange(donationManageActions.remove_food_type, foodType);
  };

  const handleSubCategoryCheck = ({ category, checked }) => {
    if (checked) {
      return onFieldChange(donationManageActions.add_food_sub_category, category);
    }

    return onFieldChange(donationManageActions.remove_food_sub_category, category);
  };

  return (
    <Box display="grid" gridAutoFlow="row" rowGap={2} width={1}>
      <Box
        sx={{
          display: 'flex',
          gap: { xs: 3, sm: 0 },
          alignItems: { xs: 'start', sm: 'center' },
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <FoodTypes
          label="Select any categories that apply:"
          error={errors}
          disabled={isLoading || !hasFoodDonorDefined}
          foodTypes={foodTypes}
          foodTypeOther={foodTypeOther}
          forceColumns
          onFoodTypeChange={handleCheck}
          onSubCategoryChange={handleSubCategoryCheck}
          onFoodTypeOtherChange={(value) => onFieldChange(donationManageActions.set_food_type_other, value)}
        />

        <LbsSelector
          label="Weight (can be estimated)"
          disabled={isLoading || !hasFoodDonorDefined}
          rescueSizeValue={rescueSizeValue}
          rescueSizes={rescueSizesArray}
          lbs={lbsValue}
          onValueChange={(newValue) => onFieldChange(donationManageActions.set_lbs_value, newValue)}
          error={errors ? errors.lbs : null}
          showOnlyTextField
          isDonationRequest
          hideOptional
        />

        <RescueSizeSelector
          rescueSizeLabel="Would size of vehicle would you recommend for this pickup?"
          disabled={isLoading || !hasFoodDonorDefined}
          value={rescueSizeValue}
          rescueSizes={rescueSizesArray}
          onChange={(value) => onFieldChange(donationManageActions.set_rescue_size, value)}
        />
      </Box>
    </Box>
  );
};

export default RequestToDonateDonationStep;
